/** The admin panel's sections and their URLs (GRO-188, B10). */
export type Section = 'users' | 'companies' | 'portfolios' | 'requests'

export const ADMIN_PATH = '/admin'

const SECTIONS: readonly Section[] = ['users', 'companies', 'portfolios', 'requests']

/** `/admin` or a path under `/admin/`; `/administrator` is not one. */
export function isAdminPath(pathname: string): boolean {
  return pathname === ADMIN_PATH || pathname.startsWith(`${ADMIN_PATH}/`)
}

/** The section a path names; null for bare `/admin`, an unknown name and any other path. */
export function sectionOf(pathname: string): Section | null {
  if (!pathname.startsWith(`${ADMIN_PATH}/`)) return null
  const name = pathname.slice(ADMIN_PATH.length + 1)
  return SECTIONS.find((s) => s === name) ?? null
}

export function sectionPath(section: Section): string {
  return `${ADMIN_PATH}/${section}`
}
